export default "__VITE_ASSET__C8tAjwKe__"